import { Platform } from 'react-native';
import RNRestart from 'react-native-restart';

type DesktopWindow = {
  go?: { main?: { App?: { RestartApplication?: () => Promise<void> } } };
};

export const restartApp = (): void => {
  if (Platform.OS === 'web') {
    if (typeof window === 'undefined') return;
    const desktopRestart = (window as unknown as DesktopWindow).go?.main?.App
      ?.RestartApplication;
    if (desktopRestart) {
      desktopRestart().catch(() => window.location.reload());
      return;
    }
    window.location.reload();
    return;
  }

  RNRestart.restart();
};
